module.exports = __webpack_public_path__ + "static/media/starPartialOff_326.f2248e1c.png";